/**
 * 通信用のURLを記載
 */
export const URL_TICKET:string				= "/ticket";
export const URL_LOGIN:string				= "/login/login";
export const URL_DASHBOARD:string           = "/dashboard/dashboard";